var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeague(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "league"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.48717 1.25C4.41403 1.25 4.34236 1.27057 4.28016 1.3094C4.21794 1.34823 4.16768 1.40379 4.13497 1.46986C4.10228 1.53592 4.08843 1.60988 4.09499 1.68344C4.10156 1.75701 4.12829 1.82727 4.17216 1.88636L5.27468 3.37066V16.6293L3.7784 18.1136C3.73452 18.1727 3.70781 18.2429 3.70125 18.3165C3.69466 18.39 3.70851 18.4641 3.74122 18.5301C3.77392 18.5962 3.8242 18.6517 3.8864 18.6906C3.9486 18.7293 4.02029 18.75 4.09341 18.75H15.5124C15.6321 18.75 15.7451 18.6951 15.8199 18.6008L17.7887 16.6121C17.8349 16.5536 17.8635 16.4831 17.8719 16.4088C17.8801 16.3343 17.8674 16.2593 17.8353 16.1917C17.8032 16.1243 17.7531 16.0674 17.6904 16.0274C17.6277 15.9875 17.5553 15.9662 17.4812 15.9659H9.21227V1.64773C9.21227 1.54224 9.17078 1.44108 9.09694 1.36649C9.0231 1.2919 8.92294 1.25 8.81851 1.25H4.48717ZM9.99979 2.84091V3.63635C13.9078 3.63635 17.0875 6.848 17.0875 10.7954C17.0875 12.4436 16.5279 13.9589 15.5979 15.1704H16.57C17.4219 13.8736 17.8757 12.3517 17.875 10.7954C17.875 6.4093 14.3422 2.84091 9.99979 2.84091ZM4.48717 5.12385C3.12633 6.47374 2.2455 8.3156 2.13642 10.3627C2.11647 10.7392 2.12266 11.1166 2.15493 11.4922C2.32228 13.4331 3.185 15.1752 4.48717 16.467V15.2846C3.46749 14.0152 2.91134 12.4301 2.91213 10.7954C2.91134 9.16079 3.46749 7.57566 4.48717 6.30629V5.12385Z",
    fill: "url(#paint0_linear_3420_139032)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3420_139032",
    x1: 14.0708,
    y1: 1.25736,
    x2: 0.91358,
    y2: 19.6734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECCA51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF8551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F49944"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeague);
export default __webpack_public_path__ + "static/media/league.ec0d83ad2d29b5296c9f23ffc266e59f.svg";
export { ForwardRef as ReactComponent };